export default __webpack_public_path__ + "static/media/pastry_topic.bb7855b7.jpg";